<div class="content-form">
  <div class="headerForm h2 accent">
    <span>{{ !boundFile ? "Création d'un lien externe" : "Modification du lien externe" }}</span>
  </div>

    <form [formGroup]="form" class="form" (keydown.enter)="$event.preventDefault()">
      <div class="content">
        <mat-form-field appearance="outline">
          <mat-label>Libellé</mat-label>
          <input matInput formControlName="label" autocomplete="off" maxlength="100" required>
        </mat-form-field>

        <mat-form-field appearance="outline">
            <mat-label>Url</mat-label>
            <input type="url" matInput formControlName="url" autocomplete="off" maxlength="500" required>
        </mat-form-field>
      </div>

      <ng-container *ngIf="!isLoading; else loadingTemplate">
        <div class="actions">
            <button mat-raised-button class="cancel" (click)="cancel()">Annuler</button>
            <button mat-raised-button class="accent" (click)="save()" [disabled]="form.invalid">
                <span>{{ !boundFile ? "Ajouter" : "Sauvegarder"}}</span>
            </button>
        </div>
      </ng-container>
      <ng-template #loadingTemplate>
        <mat-spinner [diameter]="50"></mat-spinner>
      </ng-template>
    </form>
</div>
